var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"header-row",class:{ 'header-row_centered': _vm.centered }},[_c('div',{staticClass:"logo",class:`logo_size_${_vm.logoSize}`},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"Simple App"}})]),_c('div',{staticClass:"right-col"},[_vm._t("rightCol")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }